import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Navbar, NavbarBrand, Button } from "flowbite-react";
import { logoutThunk } from "../features/auth/authSlice";
import { LuMenu } from "react-icons/lu";

export default function TopNavbar({ sidebarOpen, onToggleSidebar }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  async function onLogout() {
    await dispatch(logoutThunk());
    navigate("/login");
  }

  return (
    <Navbar
      fluid
      rounded
      className="border-b border-gray-200 dark:border-gray-800"
    >
      <div className="flex items-center gap-2">
        <Button size="sm" color="gray" onClick={onToggleSidebar}>
          <LuMenu size={18} />
        </Button>
        <NavbarBrand>
          <span className="self-center whitespace-nowrap text-xl font-semibold dark:text-white">
            Tax Deed Desk
          </span>
        </NavbarBrand>
      </div>

      <div className="flex md:order-2">
        <Button color="gray" onClick={onLogout}>
          Sair
        </Button>
      </div>
    </Navbar>
  );
}
